// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq___AeWd","container":"SectionFaq_container__yhm70","faq__title":"SectionFaq_faq__title__vpq8P","faq__list-container":"SectionFaq_faq__list-container__z0FPv"};